import { jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import { forwardRef } from "react";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { CalendarOutlined as o } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/calendar-outlined.es.es.js";
import { ClockOutlined as n } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/clock-outlined.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { generateCustomTextFieldStyle } from "../../date-picker/utils/date-picker-functions.es.js";
import { MobileDateTimePicker as MobileDateTimePicker$1 } from "../../../../node_modules/@mui/x-date-pickers/MobileDateTimePicker/MobileDateTimePicker.es.js";
const MobileDateTimePicker = forwardRef(function MobileDateTimePicker2({
  id,
  slotProps,
  disabled,
  ...rest
}, ref) {
  return /* @__PURE__ */ jsx(MobileDateTimePicker$1, { slotProps: {
    textField: {
      id,
      ...generateCustomTextFieldStyle(disabled)
    },
    tabs: {
      hidden: false,
      dateIcon: /* @__PURE__ */ jsx(o, {}),
      timeIcon: /* @__PURE__ */ jsx(n, {})
    },
    ...slotProps
  }, disabled, ...rest, ref });
});
export {
  MobileDateTimePicker
};
//# sourceMappingURL=mobile-date-time-picker.es.js.map
